import { EpimsBaseEntityDto } from './epim-base.dto';

export class NumberOfApprovalDto extends EpimsBaseEntityDto{
  NoOfApproval: Number;
  SubscriptionUserId: string;
  }
